import { render, staticRenderFns } from "./TrocarCota.vue?vue&type=template&id=ddf319cc"
import script from "./TrocarCota.vue?vue&type=script&lang=js"
export * from "./TrocarCota.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports